import angular from 'angular';
import { AddressCreateDirectiveModule } from '../../address/create/create.directive';
import { VCardEditCardholderDirectiveModule } from './cardholder/cardholder.directive';
import { VCardEditCustomerDirectiveModule } from './customer/customer.directive';

function VcardEditDirective() {
  VcardEditController.$inject = [];

  function VcardEditController() {
    const ctrl = this;

    ctrl.$onInit = function () {
      ctrl.type = ctrl.getType(ctrl.model.cardType);
    };

    ctrl.getType = function (type) {
      if (!type) {
        return 'contact';
      }

      if (ctrl.model.showCardType && ctrl.model.showCardType === 'customer') {
        return 'customer';
      }

      return 'cardholder';
    };
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/vcard/edit/edit.tpl.html',
    controllerAs: '$ctrl',
    scope: {},
    bindToController: {
      model: '=',
      modelMeta: '=',
      mode: '=',
      addresses: '=',
      validate: '@',
      showSearch: '=',
      /** Arbitrary data coming from the VcardModal */
      metadata: '<',
    },
    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },
    controller: VcardEditController,
  };
}

export const VCardEditDirectiveModule = angular
  .module('acme.common.directive.vcardEdit', [
    AddressCreateDirectiveModule,
    'acme.common.directive.vcardEditContact',
    VCardEditCardholderDirectiveModule,
    VCardEditCustomerDirectiveModule,
  ])
  .directive('vcardEdit', VcardEditDirective).name;
